import * as React from 'react';
import styled from 'styled-components';

export type TemporaryTimeComponentProps = {
  ttlInMs: number;
  disappearWithFadeOut?: boolean;
  fadeOutDurationInMs?: number;
  className?: string;
  onDisappeared?: () => void;
};

const Wrapper = styled.div<{ fadeOutDurationInMs?: number }>`
  transition: ${(props) => props.fadeOutDurationInMs}ms all ease-in-out;
  opacity: 1;
  &.fade-out {
    opacity: 0;
  }
`;

type State = {
  isVisible: boolean;
  startFadeOutAnimation: boolean;
};

const DEFAULT_FADE_OUT_DURATION_IN_MS = 1000;
export default class TemporaryTimeComponent extends React.Component<TemporaryTimeComponentProps, State> {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: true,
      startFadeOutAnimation: false,
    };
    (this as any).timer = null;
  }

  componentDidMount() {
    const timer = setTimeout(() => {
      if (!this.props.disappearWithFadeOut) this.setState({ isVisible: false });
      else {
        this.setState({ startFadeOutAnimation: true });
        (this as any).fadeOutTimer = setTimeout(() => {
          this.setState({ isVisible: false });
          if (!!this.props.onDisappeared) this.props.onDisappeared();
        }, this.props.fadeOutDurationInMs || DEFAULT_FADE_OUT_DURATION_IN_MS);
      }
    }, this.props.ttlInMs);
    (this as any).timer = timer;
  }

  componentWillUnmount() {
    clearTimeout((this as any).timer as NodeJS.Timer);
    const fadeOutTimer = (this as any).fadeOutTimer;
    if (!!fadeOutTimer) clearTimeout(fadeOutTimer);
  }

  public render() {
    return (
      this.state.isVisible && (
        <Wrapper
          fadeOutDurationInMs={this.props.fadeOutDurationInMs || DEFAULT_FADE_OUT_DURATION_IN_MS}
          className={`${this.props.className} ${this.state.startFadeOutAnimation && 'fade-out'}`}
        >
          {this.props.children}
        </Wrapper>
      )
    );
  }
}



// WEBPACK FOOTER //
// ./packages/platform-common-ui/components/TemporaryTimeComponent/index.tsx